let API_BASE = "/api";
export class ReactionConstants {
  public static API_VIEWS_BATCH_LOG = API_BASE + "/views";
}
